import {
  TOGGLE_ONBOARDING,
  TOGGLE_DRAWER,
  SET_INITIAL_REDIRECT,
  START_REDIRECT,
  END_REDIRECT,
  INIT_MAP_EDIT,
  SIGNATURE_INIT,
  TOGGLE_DEALS_OPTIONS,
  SELECT_DEFAULT_SENDING_OPTIONS,
  CHANGE_TAB,
  SET_FEATURE_MODAL,
  TOGGLE_PRICING_PAGE,
  TOGGLE_DEMO_PAGE,
  TOGGLE_PAYMENT_PAGE,
  TOGGLE_CANCEL_PAGE
} from "app/DealMachineCore/types";

import { store } from "app/store";

export const appRedirect = ({ dispatch, redirect, payload }) => {
  if (dispatch) {
    handleRedirect({ dispatch, redirect, payload });
  } else {
    return dispatch => {
      handleRedirect({ dispatch, redirect, payload });
    };
  }
};

export const setInitialRedirect = (path = "") => {
  return {
    type: SET_INITIAL_REDIRECT,
    payload: path
  };
};

const handleRedirect = ({ dispatch, redirect, payload }) => {
  switch (redirect) {
    default:
      break;

    case "getStarted":
      dispatch({ type: START_REDIRECT, payload: "/sign-up" });
      break;

    case "login":
      dispatch({ type: START_REDIRECT, payload: "/login" });
      break;

    case "register":
    case "signUp":
    case "sign_up":
      dispatch({ type: START_REDIRECT, payload: "/sign-up" });
      break;

    case "forgotPassword":
      dispatch({ type: START_REDIRECT, payload: "/forgot-password" });

      break;

    case "resetPassword":
      dispatch({ type: START_REDIRECT, payload: "/reset-password" });

      break;

    case "goForward":
      if (payload.add) {
        let new_path = window.location.pathname;
        let last_character = new_path.charAt(new_path.length - 1);
        if (last_character == "/") {
          new_path = new_path.slice(0, -1);
        }
        new_path = new_path + "/" + payload.add;
        if (payload.remove) {
          new_path.replace(payload.remove + "/", "");
        }
        dispatch({ type: START_REDIRECT, payload: new_path });
      }

      break;

    case "goBack":
      if (payload.remove) {
        let new_path = window.location.pathname;

        if (payload.remove === "property" && payload.property_id) {
          const previous_path = window.history.state.state
            ? window.history.state.state.prevUrl
            : "/";

          if (previous_path.indexOf("/a/dashboard/calendar") !== -1) {
            new_path = previous_path;
          } else if (new_path.indexOf("/a/leads") !== -1) {
            if (payload.page_id) {
              new_path = "/a/leads/" + payload.page_id;
            } else {
              new_path = "/a/leads/1";
            }
          } else if (new_path.indexOf("/a/map") !== -1) {
            new_path = "/a/map";
          } else if (new_path.indexOf("/a/dashboard/activity") !== -1) {
            new_path = "/a/dashboard/activity/leads";
          } else if (previous_path) {
            if (previous_path.indexOf("leads") !== -1) {
              new_path = previous_path;
            } else if (
              previous_path.indexOf("/a/dashboard/activity/leads") !== -1
            ) {
              new_path = previous_path;
            } else if (previous_path.indexOf("/a/dashboard/activity") !== -1) {
              new_path = previous_path;
            } else if (previous_path.indexOf("/a/map") !== -1) {
              new_path = previous_path;
            } else if (previous_path.indexOf("/a/driving") !== -1) {
              new_path = previous_path;
            } else if (previous_path.indexOf("/a/messages") !== -1) {
              new_path = previous_path;
            } else {
              new_path = new_path.replace(
                "/" + payload.remove + "/" + payload.property_id,
                ""
              );
            }
          } else {
            new_path = new_path.replace(
              "/" + payload.remove + "/" + payload.property_id,
              ""
            );
          }
        } else if (payload.remove === "route" && payload.route_id) {
          new_path = new_path.replace(
            "/" + payload.remove + "/" + payload.route_id,
            ""
          );
        } else if (payload.remove === "user" && payload.user_id) {
          new_path = new_path.replace(
            "/" + payload.remove + "/" + payload.user_id,
            ""
          );
        } else if (payload.remove === "invite" && payload.invite_id) {
          new_path = new_path.replace(
            "/" + payload.remove + "/" + payload.invite_id,
            ""
          );
        } else {
          new_path = new_path.replace("/" + payload.remove, "");
        }

        dispatch({ type: START_REDIRECT, payload: new_path });
      } else {
        switch (payload.type) {
          default:
            break;

          case "login":
            dispatch({ type: START_REDIRECT, payload: "/login" });

            break;

          case "dealsMap":
            dispatch({ type: START_REDIRECT, payload: "/a/map" });
            break;
          case "dealsList":
            dispatch({ type: START_REDIRECT, payload: "/a/list/deals" });
            break;
          case "dealsGrid":
            dispatch({ type: START_REDIRECT, payload: "/a/list/grid" });
            break;

          case "dashboard":
            dispatch({ type: START_REDIRECT, payload: "/a/dashboard" });
            break;
          case "account_activity":
            dispatch({
              type: START_REDIRECT,
              payload: "/a/dashboard/activity"
            });
            break;
          case "deals":
            if (payload.toggle) {
              switch (payload.toggle) {
                case "map":
                default:
                  dispatch({ type: START_REDIRECT, payload: "/a/map" });
                  break;
                case "list":
                  dispatch({
                    type: START_REDIRECT,
                    payload: "/a/list/deals"
                  });
                  break;

                case "grid":
                  if (payload.page) {
                    dispatch({
                      type: START_REDIRECT,
                      payload: "/a/grid/deals/page/" + payload.page
                    });
                  } else {
                    dispatch({
                      type: START_REDIRECT,
                      payload: "/a/grid/deals"
                    });
                  }
                  break;
              }
            } else {
              dispatch({ type: START_REDIRECT, payload: "/a/map" });
            }
            break;

          case "deal":
          case "deal_double":
            if (payload.id) {
              dispatch({
                type: START_REDIRECT,
                payload: "/a/deals/" + payload.id
              });
            } else if (payload.deal_id) {
              dispatch({
                type: START_REDIRECT,
                payload: "/a/deals/" + payload.deal_id
              });
            }

            break;

          case "address_options":
            dispatch({
              type: START_REDIRECT,
              payload: "/a/deals/" + payload.deal_id + "/address-options"
            });
            break;

          case "mailing_options":
            dispatch({
              type: START_REDIRECT,
              payload: "/a/deals/" + payload.deal_id + "/mailing-options"
            });
            break;

          case "analytics":
            dispatch({ type: START_REDIRECT, payload: "/a/dashboard" });
            break;

          case "billing":
          case "billingPopup":
          case "billingOnboarding":
            dispatch({
              type: START_REDIRECT,
              payload: "/a/settings/billing"
            });

            break;

          case "settings":
            dispatch({ type: START_REDIRECT, payload: "/a/settings" });

            break;

          case "tags":
            dispatch({
              type: START_REDIRECT,
              payload: "/a/settings/property-tags"
            });

            break;

          case "account":
            dispatch({
              type: START_REDIRECT,
              payload: "/a/settings/profile"
            });

            break;

          case "sending_options":
            dispatch({
              type: START_REDIRECT,
              payload: "/a/settings/mailing-options"
            });
            break;

          case "user_settings":
            dispatch({
              type: START_REDIRECT,
              payload: "/a/settings/profile"
            });
            break;

          case "team":
            dispatch({ type: START_REDIRECT, payload: "/a/team" });
            break;

          case "campaigns":
            dispatch({ type: START_REDIRECT, payload: "/a/campaigns" });
            break;

          case "campaign":
            dispatch({
              type: START_REDIRECT,
              payload: "/a/campaigns/edit/" + payload.id
            });
            break;

          case "templates":
            dispatch({ type: START_REDIRECT, payload: "/a/templates" });
            break;

          case "template":
            dispatch({
              type: START_REDIRECT,
              payload: "/a/templates/edit/" + payload.id
            });
            break;

          case "signatures":
            dispatch({ type: START_REDIRECT, payload: "/a/signatures" });
            break;

          case "partner":
            dispatch({ type: START_REDIRECT, payload: "/a/partner" });
            break;

          case "canceled":
            dispatch({ type: START_REDIRECT, payload: "/a/canceled" });
            break;

          case "team_removed":
            dispatch({ type: START_REDIRECT, payload: "/a/team-removed" });
            break;

          case "map":
            dispatch({ type: START_REDIRECT, payload: "/a/add-address" });
            break;

          case "deal_map":
            dispatch({
              type: START_REDIRECT,
              payload: "/a/deals/" + payload.deal_id + "/property-address"
            });
            break;

          case "getStarted":
            dispatch({ type: START_REDIRECT, payload: "/" });
            break;

          case "routes":
          case "driving":
            dispatch({ type: START_REDIRECT, payload: "/a/driving/routes" });
            break;

          case "drivers":
            dispatch({ type: START_REDIRECT, payload: "/a/driving/drivers" });
            break;

          case "list_builder":
            dispatch({ type: START_REDIRECT, payload: "/a/lists" });
            break;

          case "message_engine":
            dispatch({ type: START_REDIRECT, payload: "/a/messages" });
            break;

          case "enginesAndAddons":
            dispatch({
              type: START_REDIRECT,
              payload: "/a/settings/engines-and-addons"
            });

            break;
        }
      }
      break;

    case "init":
      if (
        payload.user &&
        window.location.pathname == "/a/partner" &&
        payload.user.canceled != 1
      ) {
        //dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({ type: TOGGLE_ONBOARDING, payload: true });
      } else if (
        payload.user.canceled == 1 ||
        payload.user.paused_account == 1
      ) {
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({ type: START_REDIRECT, payload: "/a/canceled" });
      } /*else if (payload.user.bad_card == 1) {
          dispatch({ type: TOGGLE_DRAWER, payload: false });
          dispatch({ type: START_REDIRECT, payload: "/a/bad-card" });
        }*/ else if (
        payload.user.accepted_latest_terms != 1
      ) {
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({
          type: START_REDIRECT,
          payload: "/a/accept-terms-of-service"
        });
      } else if (payload.user.email_verified != 1) {
        if (payload.user.finished_onboarding != 1) {
          dispatch({ type: TOGGLE_DRAWER, payload: true });
          dispatch({
            type: START_REDIRECT,
            payload: "/sign-up/verify-email-address"
          });
        } else {
          dispatch({ type: TOGGLE_DRAWER, payload: true });
          dispatch({
            type: START_REDIRECT,
            payload: "/a/settings/verify-email"
          });
        }
      } else if (payload.user.phone_verified != 1) {
        if (parseInt(payload.user.finished_onboarding) !== 1) {
          dispatch({ type: TOGGLE_DRAWER, payload: true });
          dispatch({
            type: START_REDIRECT,
            payload: "/sign-up/verify-phone-number"
          });
        } else {
          dispatch({ type: TOGGLE_DRAWER, payload: true });
          dispatch({
            type: START_REDIRECT,
            payload: "/a/settings/verify-phone"
          });
        }
      } else if (parseInt(payload.user.finished_onboarding) !== 1) {
        /*
      else if (
        !payload.user.interested_in &&
        parseInt(payload.user.finished_onboarding) !== 1
      ) {
        dispatch({
          type: START_REDIRECT,
          payload: "/sign-up/what-can-we-help-you-with"
        });
      }
      */
        dispatch({
          type: START_REDIRECT,
          payload: "/sign-up/select-option"
        });
      } else if (
        payload.user &&
        window.history.state &&
        window.history.state.state &&
        window.history.state.state.prevUrl == "/affiliate-login" &&
        payload.user.canceled != 1
      ) {
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({ type: START_REDIRECT, payload: "/a/partner" });
      } else if (
        payload.accepted_affiliate_latest_terms != 1 &&
        payload.is_partner == 1
      ) {
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({
          type: START_REDIRECT,
          payload: "/a/accept-affiliate-terms-of-service"
        });
      } else if (
        payload.user.requested_team != 0 &&
        payload.user.requested_team != null
      ) {
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({ type: START_REDIRECT, payload: "/a/requested-team" });
      } else if (
        payload.user.team_removed == 1 &&
        payload.user.team_owner != 1
      ) {
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({ type: START_REDIRECT, payload: "/a/team-removed" });
      } else if (
        payload.user.team_clearance_level == 0 &&
        payload.user.completed_team_training == 0 &&
        payload.dealfinder_page.require_training == 1
      ) {
        dispatch({ type: TOGGLE_ONBOARDING, payload: true });
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({
          type: START_REDIRECT,
          payload: "/a/onboarding/training-videos/1"
        });
      } else {
        dispatch({ type: TOGGLE_DRAWER, payload: true });

        if (payload.user && payload.type != "load") {
          dispatch({
            type: CHANGE_TAB,
            payload: "dashboard"
          });
          dispatch({ type: START_REDIRECT, payload: "/a/dashboard" });
          /*
          if (payload.user.user_settings) {
            switch (payload.user.user_settings.starting_point) {
              case "dashboard":
              default:
                dispatch({
                  type: CHANGE_TAB,
                  payload: "dashboard"
                });
                dispatch({ type: START_REDIRECT, payload: "/a/dashboard" });
                break;

              case "map":
                dispatch({
                  type: CHANGE_TAB,
                  payload: "map"
                });
                dispatch({ type: START_REDIRECT, payload: "/a/map" });
                break;

              case "leads":
                dispatch({
                  type: CHANGE_TAB,
                  payload: "leads"
                });
                dispatch({ type: START_REDIRECT, payload: "/a/leads/1" });
                break;

              case "lists":
                dispatch({
                  type: CHANGE_TAB,
                  payload: "lists"
                });
                dispatch({ type: START_REDIRECT, payload: "/a/lists" });
                break;
            }
          } else {
            dispatch({
              type: CHANGE_TAB,
              payload: "dashboard"
            });
            dispatch({ type: START_REDIRECT, payload: "/a/dashboard" });
          }
          */
        }
      }
      /*
      if (payload.user && window.location.pathname == "/a/partner" && payload.user.canceled != 1) {
        //dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({ type: TOGGLE_ONBOARDING, payload: true });
      } else if (payload.user.canceled == 1) {
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({ type: START_REDIRECT, payload: "/a/canceled" });
      } else if (payload.user.bad_card == 1) {
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({ type: START_REDIRECT, payload: "/a/bad-card" });
      } else if (payload.user.accepted_latest_terms != 1) {
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({
          type: START_REDIRECT,
          payload: "/a/accept-terms-of-service"
        });
      } else if(payload.user && window.history.state.prevUrl == "/affiliate-login" && payload.user.canceled != 1){
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({ type: START_REDIRECT, payload: "/a/partner" });
      } else if (
        payload.accepted_affiliate_latest_terms != 1 &&
        payload.is_partner == 1
      ) {
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({
          type: START_REDIRECT,
          payload: "/a/accept-affiliate-terms-of-service"
        });
      } else if (
        payload.user.requested_team != 0 &&
        payload.user.requested_team != null
      ) {
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({ type: START_REDIRECT, payload: "/a/requested-team" });
      } else if (
        payload.user.team_removed == 1 &&
        payload.user.team_owner != 1
      ) {
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({ type: START_REDIRECT, payload: "/a/team-removed" });
      } else if (
        !payload.billing.is_customer &&
        (payload.user.user_version > 1 && payload.user.team_id == 0)
      ) {
        //prompt billing
        dispatch({ type: TOGGLE_ONBOARDING, payload: true });
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({ type: START_REDIRECT, payload: "/a/settings/billing" });
      } else if (
        payload.user.team_set_signature != 1 &&
        payload.user.team_owner == 1
      ) {
        dispatch({
          type: SIGNATURE_INIT,
          payload: {
            signature: {
              title:
                payload.user.firstname +
                " " +
                payload.user.lastname +
                "'s Signature",
              signature_text: "Sincerely,",
              signature_user_id: payload.user.team_id,
              signature_other_name:
                payload.user.firstname + " " + payload.user.lastname,
              email: payload.user.team_email,
              phone: payload.user.team_phone,
              other_contact: "",
              include_image: 0,
              signature_image: "",
              address: "",
              address2: "",
              city: "",
              state: "",
              zip: "",
              disclaimer: ""
            }
          }
        });

        dispatch({ type: TOGGLE_ONBOARDING, payload: true });
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({ type: START_REDIRECT, payload: "/a/new-signature" });
      } else if (
        payload.user.team_set_credit_reload != 1 &&
        payload.user.team_owner == 1 &&
        payload.user.user_version > 0
      ) {
        dispatch({ type: TOGGLE_ONBOARDING, payload: true });
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({
          type: START_REDIRECT,
          payload: "/a/settings/billing/credit-reload"
        });
      } else if (
        payload.user.set_resend_freq != 1 &&
        payload.user.team_owner == 1
      ) {
        dispatch({ type: TOGGLE_ONBOARDING, payload: true });
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({ type: SELECT_DEFAULT_SENDING_OPTIONS, payload: true });
        dispatch({
          type: START_REDIRECT,
          payload: "/a/settings/mailing-options"
        });
      } else if (
        payload.user.team_clearance_level == 0 &&
        payload.user.completed_team_training == 0 &&
        payload.dealfinder_page.require_training == 1
      ) {
        dispatch({ type: TOGGLE_ONBOARDING, payload: true });
        dispatch({ type: TOGGLE_DRAWER, payload: false });
        dispatch({
          type: START_REDIRECT,
          payload: "/a/onboarding/training-videos/1"
        });
      } else {
        dispatch({ type: TOGGLE_DRAWER, payload: true });
        if(payload.type != "load"){
          dispatch({ type: START_REDIRECT, payload: '/a/dashboard' });
        }
      }
      */

      break;

    case "logout":
      dispatch({ type: START_REDIRECT, payload: "/" });

      break;

    case "dashboard_interested_in":
      dispatch({ type: TOGGLE_DRAWER, payload: true });

      const interest = window.localStorage.getItem("interest");
      switch (interest) {
        default:
        case "crm":
          dispatch({ type: START_REDIRECT, payload: "/a/dashboard" });
          break;

        case "street":
        case "driving":
          dispatch({
            type: SET_FEATURE_MODAL,
            payload: {
              slug: "driving"
            }
          });

          dispatch({
            type: START_REDIRECT,
            payload: "/a/driving/routes/get-feature"
          });
          //window.localStorage.setItem("interest", null);
          break;

        case "lists":
        case "list":
          dispatch({
            type: SET_FEATURE_MODAL,
            payload: {
              slug: "lists"
            }
          });
          dispatch({
            type: START_REDIRECT,
            payload: "/a/lists/build-list/get-feature"
          });
          //  window.localStorage.setItem("interest", null);

          break;
      }

      break;
    case "messages_completed_signup":
      dispatch({ type: TOGGLE_DRAWER, payload: true });
      dispatch({
        type: START_REDIRECT,
        payload: "/a/messages/completed-sign-up"
      });
      break;
    case "lists_completed_signup":
      dispatch({ type: TOGGLE_DRAWER, payload: true });
      dispatch({
        type: START_REDIRECT,
        payload: "/a/lists/completed-sign-up"
      });
      break;
    case "crm_completed_signup":
      dispatch({ type: TOGGLE_DRAWER, payload: true });
      dispatch({
        type: START_REDIRECT,
        payload: "/a/crm/completed-sign-up"
      });
      break;
    case "dashboard_completed_signup":
      dispatch({ type: TOGGLE_DRAWER, payload: true });
      dispatch({
        type: START_REDIRECT,
        payload: "/a/dashboard/completed-sign-up"
      });

      break;
    case "dashboard":
    case "main":
      dispatch({ type: TOGGLE_DRAWER, payload: true });
      dispatch({ type: START_REDIRECT, payload: "/a/dashboard" });

      break;

    case "deals":
    case "map":
      dispatch({ type: TOGGLE_DRAWER, payload: true });
      dispatch({ type: START_REDIRECT, payload: "/a/map" });

      break;

    case "leads":
    case "leads_push":
      const page_id = payload ? (payload.page_id ? payload.page_id : 1) : 1;
      const active_property = payload
        ? payload.active_property
          ? payload.active_property
          : null
        : null;
      if (active_property) {
        dispatch({
          type: START_REDIRECT,
          payload:
            "/a/leads/" + page_id + "/property/" + active_property.property_id
        });
      } else {
        const path = window.location.pathname;
        if (path.indexOf("lead-filters") !== -1) {
          dispatch({
            type: START_REDIRECT,
            payload: "/a/leads/" + page_id + "/lead-filters"
          });
        } else if (path.indexOf("lead-options") !== -1) {
          dispatch({
            type: START_REDIRECT,
            payload: "/a/leads/" + page_id + "/lead-options"
          });
        } else {
          dispatch({ type: START_REDIRECT, payload: "/a/leads/" + page_id });
        }
      }
      break;

    case "lists":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/leads/" + payload.page_id + "/lists"
      });
      break;

    case "listSettings":
      dispatch({ type: START_REDIRECT, payload: "/a/settings/lists" });
      break;

    case "status":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/leads/" + payload.page_id + "/lead-status"
      });

      break;

    case "send_message":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/leads/" + payload.page_id + "/send-text-messages"
      });
      break;

    case "leadfilters":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/leads/" + payload.page_id + "/lead-filters"
      });
      break;

    case "addlead":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/leads/1/manually-add-lead"
      });
      break;

    case "leadoptions":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/leads/" + payload.page_id + "/lead-options"
      });
      break;
    case "mapFilters":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/map/highlight-properties"
      });
      break;

    case "defaultLocation":
      dispatch({ type: START_REDIRECT, payload: "/a/map/default-location" });
      break;

    case "property":
      if (payload.page_id) {
        dispatch({
          type: START_REDIRECT,
          payload:
            "/a/leads/" + payload.page_id + "/property/" + payload.property_id
        });
      } else if (payload.map === "default") {
        const path = window.location.pathname;
        if (path.indexOf("map") !== -1) {
          dispatch({
            type: START_REDIRECT,
            payload: "/a/map/property/" + payload.property_id
          });
        } else {
          dispatch({
            type: START_REDIRECT,
            payload: "/a/property/" + payload.property_id
          });
        }
      } else if (payload.map) {
        dispatch({
          type: START_REDIRECT,
          payload: "/a/map/property/" + payload.property_id
        });
      } else if (payload.dashboard) {
        dispatch({
          type: START_REDIRECT,
          payload: "/a/dashboard/property/" + payload.property_id
        });
      } else {
        dispatch({
          type: START_REDIRECT,
          payload: "/a/property/" + payload.property_id
        });
      }
      break;

    case "dealsMap":
      dispatch({
        type: TOGGLE_DEALS_OPTIONS,
        payload: "map"
      });

      dispatch({ type: START_REDIRECT, payload: "/a/map" });
      break;

    case "deals_list":
    case "dealsList":
      dispatch({
        type: TOGGLE_DEALS_OPTIONS,
        payload: "list"
      });

      dispatch({ type: START_REDIRECT, payload: "/a/list/deals" });
      break;

    case "deals_grid":
    case "dealsGrid":
      dispatch({
        type: TOGGLE_DEALS_OPTIONS,
        payload: "grid"
      });

      if (payload) {
        dispatch({
          type: START_REDIRECT,
          payload: "/a/grid/deals/page/" + payload.page_id
        });
      } else {
        dispatch({ type: START_REDIRECT, payload: "/a/grid/deals" });
      }

      break;

    case "editDeals":
      dispatch({ type: START_REDIRECT, payload: "/a/edit-deals" });
      break;

    case "deal":
    case "dealActivity":
      if (payload.deal) {
        dispatch({
          type: START_REDIRECT,
          payload: "/a/deals/" + payload.deal.id
        });
      } else {
        dispatch({
          type: START_REDIRECT,
          payload: "/a/deals/" + payload.deal_id
        });
      }
      break;

    case "verifyEmail":
      dispatch({ type: START_REDIRECT, payload: "/a/settings/verify-email" });
      break;

    case "verifyPhone":
      dispatch({ type: START_REDIRECT, payload: "/a/settings/verify-phone" });
      break;

    case "onboardingVerifyPhone":
      dispatch({
        type: START_REDIRECT,
        payload: "/sign-up/verify-phone-number"
      });
      break;

    case "onboardingIntestedIn":
      dispatch({
        type: START_REDIRECT,
        payload: "/sign-up/what-can-we-help-you-with"
      });
      break;
    case "onboardingSelectPlans":
      dispatch({
        type: START_REDIRECT,
        payload: "/sign-up/select-option"
      });
      break;

    case "onboardingConfirmPayment":
      dispatch({
        type: START_REDIRECT,
        payload: "/sign-up/confirm-payment"
      });
      break;

    case "signatureOnboarding":
      dispatch({
        type: SIGNATURE_INIT,
        payload: {
          signature: {
            title:
              payload.user.firstname +
              " " +
              payload.user.lastname +
              "'s Signature",
            signature_text: "Sincerely,",
            signature_user_id: payload.user.team_id,
            signature_other_name:
              payload.user.firstname + " " + payload.user.lastname,
            email: payload.user.team_email,
            phone: payload.user.team_phone,
            other_contact: "",
            include_image: 0,
            signature_image: "",
            address: "",
            address2: "",
            city: "",
            state: "",
            zip: "",
            disclaimer: ""
          }
        }
      });

      dispatch({ type: TOGGLE_ONBOARDING, payload: true });
      dispatch({ type: TOGGLE_DRAWER, payload: false });
      dispatch({ type: START_REDIRECT, payload: "/a/new-signature" });

      break;

    case "requestToJoinTeam":
      dispatch({ type: START_REDIRECT, payload: "/a/request-to-join-team" });
      break;

    case "new_deal":
      dispatch({ type: START_REDIRECT, payload: "/a/deals/" + payload.id });
      break;

    case "activity":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/account-activity"
      });
      break;

    case "analytics":
      dispatch({ type: START_REDIRECT, payload: "/a/dashboard" });
      break;

    case "analytics_filters":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/dashboard/filter-analytics"
      });
      break;

    case "driving_analytics_filters":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/driving/filter-analytics"
      });
      break;

    case "list_builder":
      dispatch({ type: START_REDIRECT, payload: "/a/lists" });
      break;

    case "message_engine":
      dispatch({ type: START_REDIRECT, payload: "/a/messages" });
      break;

    case "conversation_item":
      if (payload && payload.conversation_id) {
        dispatch({
          type: START_REDIRECT,
          payload: "/a/messages/conversation/" + payload.conversation_id
        });
      }
      break;
    case "conversation_settings":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/messages/conversation-settings"
      });
      break;
    case "manage_phone_numbers":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/messages/manage-phone-numbers"
      });
      break;
    case "manage_saved_replies":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/messages/manage-saved-replies"
      });
      break;
    case "list_item":
    case "list_item_replace":
      if (payload) {
        dispatch({
          type: START_REDIRECT,
          payload: "/a/lists/view/" + payload.id
        });
      }
      break;

    case "build_list":
      dispatch({ type: START_REDIRECT, payload: "/a/lists/build-list" });
      break;

    case "routes":
    case "driving":
      dispatch({ type: START_REDIRECT, payload: "/a/driving/routes" });
      break;

    case "drivers":
      dispatch({ type: START_REDIRECT, payload: "/a/driving/drivers" });
      break;

    case "inviteDriver":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/driving/drivers/invite"
      });
      break;

    case "route":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/driving/routes/route/" + payload.id
      });
      break;

    case "templates":
      dispatch({ type: START_REDIRECT, payload: "/a/templates" });
      break;

    case "editTemplate":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/templates/edit/" + payload.id
      });
      break;
    case "dealEditTemplate":
    case "campaignsEditTemplate":
    case "settingsEditTemplate":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/new-template"
      });
      break;

    case "newTemplate":
    case "settingsNewTemplate":
    case "dealNewTemplate":
      dispatch({ type: START_REDIRECT, payload: "/a/new-template" });
      break;

    case "signatures":
      dispatch({ type: START_REDIRECT, payload: "/a/signatures" });
      break;

    case "editSignature":
    case "dealEditSignature":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/signatures/edit/" + payload.id
      });
      break;

    case "newSignature":
    case "campaignsEditSignature":
    case "templatesEditSignature":
    case "settingsEditSignature":
    case "settingsNewSignature":
    case "dealNewSignature":
      dispatch({ type: START_REDIRECT, payload: "/a/new-signature" });
      break;

    case "settings":
      dispatch({ type: START_REDIRECT, payload: "/a/settings" });
      break;

    case "bulkUploadMapping":
      if (window.location.pathname.indexOf("/a/leads") !== -1) {
        let list_properties_page = 1;
        //const list_properties_page = store.getState().leads.list_properties_page;
        if (list_properties_page) {
          dispatch({
            type: START_REDIRECT,
            payload:
              "/a/leads/" + list_properties_page + "/uploaded-list-mapping"
          });
        } else {
          dispatch({
            type: START_REDIRECT,
            payload: "/a/settings/uploaded-list-mapping"
          });
        }
      } else {
        dispatch({
          type: START_REDIRECT,
          payload: "/a/settings/uploaded-list-mapping"
        });
      }

      break;

    case "bulkUploadOptions":
      if (window.location.pathname.indexOf("/a/leads") !== -1) {
        const list_properties_page = store.getState().lead.list_properties_page;
        if (list_properties_page) {
          dispatch({
            type: START_REDIRECT,
            payload:
              "/a/leads/" + list_properties_page + "/uploaded-list-options"
          });
        } else {
          dispatch({
            type: START_REDIRECT,
            payload: "/a/settings/uploaded-list-options"
          });
        }
      } else {
        dispatch({
          type: START_REDIRECT,
          payload: "/a/settings/uploaded-list-options"
        });
      }

      break;

    case "customTags":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/property-tags"
      });
      break;

    case "createTag":
    case "dealCreateTag":
      dispatch({ type: START_REDIRECT, payload: "/a/settings/create-tag" });
      break;

    case "changePropertyStatus":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/deals/" + payload.id + "/property-status"
      });
      break;

    case "account":
      dispatch({ type: START_REDIRECT, payload: "/a/settings/profile" });
      break;

    case "billing":
      dispatch({ type: START_REDIRECT, payload: "/a/settings/billing" });
      break;

    case "billingOnboarding":
      dispatch({ type: TOGGLE_ONBOARDING, payload: true });
      dispatch({ type: START_REDIRECT, payload: "/a/settings/billing" });
      break;

    case "billingAddons":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/billing/manage-features"
      });
      break;

    case "cardOnFile":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/billing/update-card"
      });
      break;
    case "getFeatureDriving":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/map/get-feature"
      });
      break;
    case "getFeatureLists":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/lists/get-feature"
      });
      break;
    case "getFeature":
    case "getFeatureMessages":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/engines-and-addons/get-feature"
      });
      break;

    case "currentPlan":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/billing/current-plan"
      });
      break;

    case "cancelPlan":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/billing/cancel-plan"
      });
      break;

    case "cancel":
      if (payload) {
        switch (payload.slug) {
          case "driving":
          default:
            dispatch({
              type: START_REDIRECT,
              payload: "/a/settings/cancel/driving"
            });
            break;

          case "lists":
            dispatch({
              type: START_REDIRECT,
              payload: "/a/settings/cancel/lists"
            });
            break;

          case "messages":
            dispatch({
              type: START_REDIRECT,
              payload: "/a/settings/cancel/messages"
            });
            break;
        }
      }
      break;

    case "sellLeads":
      dispatch({ type: TOGGLE_DRAWER, payload: true });
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/billing/sell-leads"
      });
      break;

    case "mailingInformation":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/mailing-information"
      });
      break;

    case "sendingOptions":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/mailing-options"
      });
      break;

    case "editUserInfo":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/profile/user-information"
      });
      break;

    case "editEmail":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/profile/change-email"
      });
      break;

    case "editPassword":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/profile/change-password"
      });
      break;
    case "account_activity":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/dashboard/activity"
      });
      break;
    case "calendar":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/dashboard/calendar"
      });
      break;
    case "mailer_calendar":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/calendar"
      });
      break;
    case "notification_leads":
    case "activity_leads":
      let new_path = window.location.pathname;
      new_path = new_path + "/leads";
      dispatch({ type: START_REDIRECT, payload: new_path });
      break;

    case "notifications":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/notifications"
      });
      break;

    case "promo":
      dispatch({ type: START_REDIRECT, payload: "/a/settings/enter-promo" });
      break;

    case "team":
      dispatch({ type: START_REDIRECT, payload: "/a/team" });
      break;

    case "inviteTeamMember":
      dispatch({ type: START_REDIRECT, payload: "/a/team/invite" });
      break;

    case "badges":
      dispatch({ type: START_REDIRECT, payload: "/a/settings/badges" });
      break;

    case "teamMember":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/team/member/" + payload.id
      });
      break;

    case "teamInvite":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/team/invite/" + payload.id
      });
      break;

    case "dealfinderInvite":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/driving/drivers/invite/" + payload.id
      });
      break;

    case "dealfinder":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/driving/drivers/user/" + payload.id
      });
      break;

    case "user":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/team/user/" + payload.id
      });
      break;

    case "invite":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/team/invite/" + payload.id
      });
      break;

    case "collectDealFinders":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/driving/drivers/recruit-drivers"
      });
      break;

    case "previewTemplate":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/templates/edit/" + payload.id + "/preview"
      });
      break;

    case "previewDeal":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/deals/" + payload.id + "/mailing-options/preview"
      });
      break;

    case "editOwnerName":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/deals/" + payload.deal_id + "/edit-owner-name"
      });
      break;

    case "editDealWon":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/deals/" + payload.deal_id + "/purchase-details"
      });
      break;

    case "repeatMailHouse":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/deals/" + payload.deal_id + "/mailing-options/repeat-mail"
      });
      break;

    case "repeatMail":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/mailing-options/repeat-mail"
      });
      break;

    case "mailingOptionsOnboarding":
      dispatch({ type: SELECT_DEFAULT_SENDING_OPTIONS, payload: true });
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/mailing-options"
      });
      break;

    case "editOwnerAddress":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/deals/" + payload.deal_id + "/mailing-options/address"
      });
      break;

    case "addressOptions":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/deals/" + payload.deal_id + "/address-options"
      });
      break;

    case "mailingOptions":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/deals/" + payload.deal_id + "/mailing-options"
      });
      break;

    case "editAddress":
      dispatch({
        type: START_REDIRECT,
        payload:
          "/a/deals/" + payload.deal_id + "/mailing-options/additional-address"
      });
      break;

    case "emailOptions":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/deals/" + payload.deal_id + "/email-options"
      });
      break;

    case "editOwnerEmail":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/deals/" + payload.deal_id + "/email-options/email"
      });
      break;

    case "phoneOptions":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/deals/" + payload.deal_id + "/phone-options"
      });
      break;

    case "editPhone":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/deals/" + payload.deal_id + "/phone-options/edit-phone"
      });
      break;

    case "manuallyEnterOwnerAddress":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/deals/" + payload.deal_id + "/manually-enter-owner-address"
      });
      break;

    case "manuallyAddProperty":
    case "manuallyAddLead":
      dispatch({ type: START_REDIRECT, payload: "/a/map/manually-add-lead" });
      break;

    case "mapOptions":
      dispatch({ type: START_REDIRECT, payload: "/a/map/map-options" });

      break;

    case "selectTemplate":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/mailing-options/default-template"
      });
      break;

    case "selectHouseTemplate":
      dispatch({
        type: START_REDIRECT,
        payload:
          "/a/deals/" + payload.deal_id + "/mailing-options/select-template"
      });
      break;

    case "upload_list":
      dispatch({ type: START_REDIRECT, payload: "/a/upload-list" });
      break;

    case "gallery":
      break;

    case "camera":
      break;

    case "add_address":
      dispatch({ type: START_REDIRECT, payload: "/a/add-address" });
      break;

    case "mapEdit":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/deals/" + payload.deal_id + "/property-address/"
      });
      break;

    case "mapManualAddress":
    case "manualAddress":
      dispatch({
        type: INIT_MAP_EDIT,
        payload: {
          mapEdit: {
            editing: false,
            deal_id: null,
            address: "",
            lat: null,
            long: null
          }
        }
      });
      dispatch({ type: START_REDIRECT, payload: "/a/manual-address" });
      break;

    case "mapEditManualAddress":
      dispatch({
        type: START_REDIRECT,
        payload:
          "/a/deals/" + payload.deal_id + "/property-address/manual-address"
      });

      break;

    case "requestedTeam":
      dispatch({ type: START_REDIRECT, payload: "/a/requested-team" });
      break;

    case "requestTeam":
      dispatch({ type: START_REDIRECT, payload: "/a/request-to-join-team" });
      break;

    case "share":
      dispatch({ type: START_REDIRECT, payload: "/a/share" });
      break;

    case "editNote":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/deals/" + payload.deal_id + "/edit-note"
      });
      break;

    case "mailTimeline":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/deals/" + payload.deal_id + "/mail-tracking"
      });
      break;

    case "partner":
      dispatch({ type: START_REDIRECT, payload: "/a/partner" });
      break;

    case "editPaypalEmail":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/partner/edit-paypal-email"
      });
      break;

    case "editPartnerWebsite":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/partner/edit-partner-website"
      });
      break;

    case "TrainingVideos":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/training-videos"
      });
      break;

    case "creditReload":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/billing/credit-reload"
      });
      break;

    case "creditReloadOnboarding":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/billing/credit-reload"
      });
      break;

    case "purchaseCredits":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/billing/purchase-credit"
      });
      break;

    case "invoices":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/billing/invoices"
      });
      break;

    case "campaigns":
      dispatch({ type: START_REDIRECT, payload: "/a/campaigns" });
      break;

    case "editCampaign":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/campaigns/edit/" + payload.id
      });
      break;

    case "newCampaign":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/campaigns/new-campaign"
      });
      break;

    case "trainingVideosOnboarding":
      dispatch({ type: TOGGLE_ONBOARDING, payload: true });
      dispatch({ type: TOGGLE_DRAWER, payload: false });
      dispatch({
        type: START_REDIRECT,
        payload: "/a/onboarding/training-videos/" + payload.id
      });

      break;

    case "training":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/training-videos"
      });

      break;

    case "enginesAndAddons":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/engines-and-addons"
      });

      break;

    case "billingDetails":
      dispatch({
        type: START_REDIRECT,
        payload: "/a/settings/engines-and-addons/billing-details"
      });

      break;
    case "canceled":
      dispatch({ type: TOGGLE_ONBOARDING, payload: true });
      dispatch({ type: TOGGLE_DRAWER, payload: false });

      dispatch({ type: START_REDIRECT, payload: "/a/canceled" });
      break;
  }
};

export const startRedirect = redirect => {
  return {
    type: START_REDIRECT,
    payload: redirect
  };
};
export const endRedirect = redirect => {
  return {
    type: END_REDIRECT
  };
};

export const togglePricingPage = toggle => {
  return {
    type: TOGGLE_PRICING_PAGE,
    payload: toggle
  };
};

export const toggleDemoPage = toggle => {
  return {
    type: TOGGLE_DEMO_PAGE,
    payload: toggle
  };
};

export const togglePaymentPage = toggle => {
  return {
    type: TOGGLE_PAYMENT_PAGE,
    payload: toggle
  };
};

export const toggleCancelPage = toggle => {
  return {
    type: TOGGLE_CANCEL_PAGE,
    payload: toggle
  };
};
